import Co2Footprint from "./co2Footprint.container";

export default Co2Footprint;
